import React from "react";
import { Helmet } from "react-helmet";
import ContactForm from '../components/ContactForm'
import LocationMap from '../components/LocationMap'
import HeroSlider from "../components/HeroSlider";
import { useTranslation } from 'react-i18next';
const ContactUs = () => {
  const {t} = useTranslation();
  
  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>
            Contact Us | Min & Ying Legal Services Professional Corporation
          </title>
          
          <meta
            name="description"
            content="Contact Us | Min & Ying Legal Services Professional Corporation"
          />
        </Helmet>

        <HeroSlider/>
        {/* HERO=========== */}
        {/* <div className="container-fluid">
          <div className="row">
            <div className="hero-section">
              <div className="hero-overlay"></div>
              <div className="text-container d-flex flex-column justify-content-start align-items-start pt-6 slide">
                <div className="text-1 fs-2 pb-3">Min & Ying Legal Services Professional Corporation Professional Corporation</div>
                <div className="text-2 fs-4">
                  BIROU DE AVOCAT SI INSOLVENTA
                  <span className="fw-bold">
                    <br></br> Bucuresti{" "}
                  </span>
                </div>
                <div className="text-3 fst-italic fw-light">
                  "Nu este o adevărată justiție acolo unde nu există dreptate,
                  iar dreptatea nu poate fi găsită acolo unde nu există adevăr."
                  - <span>Lucius Annaeus Seneca.</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="container-fluid container">
          <div className="row p-5 mobile-padding align-items-start justify-content-center mr-5">
            <h5 className="guide-text font-weight-bold mb-3">{t('contactUs.ourLocation')}</h5>
            <div className="col-12 col-lg-6 mb-5">
               <div className="contact-item d-flex align-items-start mb-3">
                <span className="text-dark">
                  Unit 2A31, 4675 Steeles Ave. E
                  Scarborough, ON M1V 0B7
                </span>
              </div>
              <LocationMap />
            </div>
            <div className="col-12 col-lg-6 shadow-none bg-light rounded condensed-contact-form">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
